/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import { TabsList } from "../../../models";
import { getProjectDetails } from "../../../service/publicquery";
import { Status } from "../../../service/Shared";
import { PublicProjectTemplate } from "../../../templates";
import {
  getPublicProjectDetailsRoute,
  getPublicProjectDocumentsRoute,
  getPublicProjectInventoryRoute,
  getPublicProjectOverviewRoute,
} from "../../../utils/routes";

const Project = (): JSX.Element => {
  const { uuid } = useParams();
  const [searchParams] = useSearchParams();
  const [hideInventory, setHideInventory] = useState(false);

  // REQ-014: hide the Inventory tab when the project has no unit measurements (null or empty, e.g. No standard projects).
  useEffect(() => {
    if (!uuid) {
      return undefined;
    }

    let active = true;

    getProjectDetails({ projectUuid: uuid })
      .then((res) => {
        if (active && res.status === Status.Success && res.data) {
          setHideInventory(!res.data.unitMeasurements?.length);
        }
      })
      .catch(() => {
        if (active) {
          setHideInventory(false);
        }
      });

    return () => {
      active = false;
    };
  }, [uuid]);

  const tabsList: TabsList = [
    {
      label: "Overview",
      route: `${getPublicProjectOverviewRoute(uuid!)}?${searchParams}`,
    },
    {
      label: "Details",
      route: `${getPublicProjectDetailsRoute(uuid!)}?${searchParams}`,
    },
    {
      label: "Documents",
      route: `${getPublicProjectDocumentsRoute(uuid!)}?${searchParams}`,
    },
    // REQ-014: Inventory tab is hidden when the project has no unit measurements.
    ...(!hideInventory
      ? [
          {
            label: "Inventory",
            route: `${getPublicProjectInventoryRoute(uuid!)}?${searchParams}`,
          },
        ]
      : []),
  ];
  return <PublicProjectTemplate activeElement="Project list" tabsList={tabsList} />;
};

export default Project;
